import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Image } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { RootState } from '../store';
import { Favorite, Summary } from '../store/user/types';
import { useApi } from '../api/contexts/ApiContext';
import { Spinner } from "react-bootstrap";
const Dashboard: React.FC<{ mode: string }> = ({ mode }) => {
    const [summary, setSummary] = useState<Summary>();
    const [favorite, setFavorite] = useState<Favorite>();
    const { winRatio } = useSelector((state: RootState) => state.winRatio);
    const { userInfo } = useSelector((state: RootState) => state.auth);
    const { vendorInfo } = useSelector((state: RootState) => state.vendor);
    const { getModule } = useApi();
    const location = useLocation();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const queryParams = new URLSearchParams(location.search);
    const initialMode = queryParams.get('mode') === 'facility' ? 'facility' : 'company';

    useEffect(() => {
        const fetchCompanyById = async () => {
            if (userInfo) {
                try {
                    const generalApi = await getModule('GeneralApi');
                    const response = await generalApi.getCompanyAndFacilityCount({ vendor_id: vendorInfo?.vendor_id, user_id: userInfo.id });
                    setSummary(response.data);
                    const favoriteResponse = await generalApi.getFavoriteCount({ vendor_id: vendorInfo?.vendor_id, user_id: userInfo.id });
                    setFavorite(favoriteResponse.data);
                } catch (error) {
                    console.error("Failed to fetch company:", error);
                } finally {
                    setIsLoading(false);
                }
            }
        };
        fetchCompanyById();

    }, [getModule, userInfo]);


    const date = new Date();
    const [currentMonth, currentDay, currentYear] = [
        date.getMonth() + 1,
        date.getDate(),
        date.getFullYear(),
    ];

    const unit = mode === "facility" ? "施設" : "社";
    const winCount = winRatio?.ratio.win[mode as keyof typeof winRatio.ratio.win];
    const loseCount = winRatio?.ratio.lose[mode as keyof typeof winRatio.ratio.lose];
    const ratio = (typeof winCount === 'number' && typeof loseCount === 'number' && loseCount !== 0)
        ? winCount / loseCount
        : 0;

    const renderSummaryItem = (color: string, title: string, countKey: keyof Summary, usageKey: keyof Summary, icon: string) => (
        <div className={`col-lg-4`}>
            <div className={`bg-item-wrapper bg-item-wrapper-${color} mb-lg-0 mb-3`}>
                <p className={`text-xs text-${color} mb-2 fw-400`}>{title}</p>
                <div className="text-xs fw-400">
                    <img className="height-35 mb-3 me-2" src={`assets/images/other/${icon}.svg`} />
                    <span className="text-digit text-extra-xl">
                        {summary ? summary[countKey] : 0} </span><span className="text-xs">{unit} </span>
                </div>
                <p className="fw-300 text-ass-deep-demo-02">{summary ? summary[usageKey] : 0} kWh</p>
                <a href="bidding">
                    <div className="btn btn-sm btn-theme-custom-sm rounded-pill w-100 pb-4">詳しく ≫</div>
                </a>
            </div>
        </div>
    );

    const renderFavoriteItem = (countKey: keyof Favorite, usageKey: keyof Favorite) => (
        <div className="col px-0">
            <div className="fw-300">
                <span className="text-md fw-400">{favorite ? favorite[countKey] : 0}</span>
                <span className="text-xs">{unit}</span>
            </div>
            <p className="text-ass-deep-demo-02">{favorite ? favorite[usageKey] : 0} kWh</p>
        </div>
    );

    return (

        <div className="row mx-0 text-center">
            <div className="col-lg-10 mx-auto px-0">
                <div className="row item-section mb-lg-5 mb-4">
                    {renderSummaryItem("orange", "応札中", `${mode}_count_2` as keyof Summary, "usage_total_2", "item-02")}
                </div>
                <div className="table-custom mb-lg-5 mb-4">
                    <div className="text-xs fw-400 mb-3">
                        <Image className="height-20 mb-2 me-2" src="assets/images/other/icon-star-yellow-deep.svg" />お気に入り
                    </div>
                    <div className="table-custom-wrapper">
                        <div className="row header-row mx-0 text-xs-2 fw-400">
                            <div className="col bg-ass-demo px-0">締切までの残り時間</div>
                            <div className="col bg-ass-demo px-0 text-red-01">
                                <Image className="height-20 me-2" src="assets/images/other/icon-process-red.svg" />24時間以内
                            </div>
                            <div className="col bg-ass-demo px-0 text-orange-02">
                                <Image className="height-20 me-2" src="assets/images/other/icon-process-orange.svg" />1～3日以内
                            </div>
                            <div className="col bg-ass-demo px-0">
                                <Image className="height-20 me-2" src="assets/images/other/icon-process-blue.svg" />3日以上
                            </div>
                        </div>
                        <div className="row body-row mx-0">
                            <div className="col px-0">
                                <div className="">
                                    <Image className="height-30 mb-2 me-2" src="assets/images/other/icon-pie-chart.svg" />
                                    <span className="text-xs fw-300">合計</span>
                                </div>
                                <Link to={`/search_result?category=favorite`} state={{ category: "favorite" }}>
                                    <div className="btn btn-sm btn-theme-custom-sm rounded-pill bg-red-02 text-white pb-4 px-32">
                                        詳しく ≫
                                    </div>
                                </Link>
                            </div>
                            {renderFavoriteItem(`${mode}_count_1` as keyof Favorite, "usage_total_1")}
                            {renderFavoriteItem(`${mode}_count_2` as keyof Favorite, "usage_total_2")}
                            {renderFavoriteItem(`${mode}_count_3` as keyof Favorite, "usage_total_3")}
                        </div>
                        <div className="px-lg-5 px-4">
                            <hr />
                        </div>
                        <div className="row body-row mx-0">
                            <div className="col px-0">
                                <div className="">
                                    <Image className="height-30 mb-2 me-2" src="assets/images/other/icon-medal.svg" />
                                    <span className="text-xs fw-300">応札中</span>
                                </div>
                                <Link to="/bidding">
                                    <div className="btn btn-sm btn-theme-custom-sm rounded-pill bg-red-02 text-white px-32 pb-4">
                                        詳しく ≫
                                    </div>
                                </Link>
                            </div>
                            {renderFavoriteItem(`${mode}_count_4` as keyof Favorite, "usage_total_4")}
                            {renderFavoriteItem(`${mode}_count_5` as keyof Favorite, "usage_total_5")}
                            {renderFavoriteItem(`${mode}_count_6` as keyof Favorite, "usage_total_6")}
                        </div>
                    </div>
                </div>
            </div>
        </div>


    );
};

export default Dashboard;